import React from 'react'

type ButtonProps = Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'type'> & {
  id: string
  children: React.ReactNode
  size?: 'xsmall' | 'small' | 'medium' | 'large' | 'xlarge'
  variant?: 'primary' | 'secondary' | 'tertiary' | 'danger'
  className?: string
  onClick?: React.MouseEventHandler<HTMLButtonElement>
  type?: React.ButtonHTMLAttributes<HTMLButtonElement>['type']
  disabled?: boolean
}

const Button: React.FC<ButtonProps> = ({
  id,
  children,
  className,
  size = 'medium',
  onClick,
  variant = 'primary',
  type = 'button',
  ...props
}: ButtonProps) => (
  <button
    id={id}
    name={id}
    onClick={onClick || (() => null)}
    className={variant + ' btn-' + size + ' ' + className}
    type={type}
    {...props}
  >
    {children}
  </button>
)

export default Button
